<template>
  <div class="crud_form_wrapper app_settings_class">
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: var(--main_theme_clr)" class="font-weight-bold">
          {{ $t("SIDENAV.settings.general") }}
        </h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: var(--main_theme_clr)">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <section class="settings_section">
          <h6 class="settings_section_title">
            {{ $t("PLACEHOLDERS.bookingSettingsSection") }}
          </h6>
          <div class="row">
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.vat_percentage')"
              v-model.trim="data.vat_percentage"
              step="0.01"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.usd_to_sar_rate')"
              v-model.trim="data.usd_to_sar_rate"
              step="any"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.deposit_percentage')"
              v-model.trim="data.deposit"
              step="0.01"
              min="0"
              max="100"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.affiliate_discount_percentage')"
              v-model.trim="data.affiliate_discount_percentage"
              step="0.01"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.payout_release_hours')"
              v-model.trim="data.payout_release_hours"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.hold_percent')"
              v-model.trim="data.hold_percent"
              step="0.01"
              min="0"
              max="100"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.delivery_grace_period_hours')"
              v-model.trim="data.delivery_grace_period_hours"
              min="0"
            />
          </div>
        </section>

        <section class="settings_section">
          <h6 class="settings_section_title">
            {{ $t("PLACEHOLDERS.commissionsSection") }}
          </h6>
          <div class="row">
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.commission_client')"
              v-model.trim="data.commission_client"
              step="0.01"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.commission_provider')"
              v-model.trim="data.commission_provider"
              step="0.01"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.commission_services')"
              v-model.trim="data.commission_services"
              step="0.01"
              min="0"
            />
          </div>
        </section>

        <section class="settings_section">
          <h6 class="settings_section_title">
            {{ $t("PLACEHOLDERS.penaltiesCancellationSection") }}
          </h6>
          <div class="row">
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.client_cancellation_window_days')"
              v-model.trim="data.client_cancellation_window_days"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.client_cancellation_penalty_percent')"
              v-model.trim="data.client_cancellation_penalty_percent"
              step="0.01"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.provider_cancellation_window_days')"
              v-model.trim="data.provider_cancellation_window_days"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.provider_cancellation_penalty_percent')"
              v-model.trim="data.provider_cancellation_penalty_percent"
              step="0.01"
              min="0"
            />
            <base-input
              type="number"
              col="6"
              :placeholder="$t('PLACEHOLDERS.late_fee_per_hour')"
              v-model.trim="data.late_fee_per_hour"
              step="0.01"
              min="0"
            />
          </div>
        </section>

        <div class="btn_wrapper">
          <base-button
            class="mt-2"
            styleType="primary_btn"
            :btnText="$t('BUTTONS.save')"
            :isLoading="isWaitingRequest"
            :disabled="isWaitingRequest"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
const SETTING_KEYS = [
  "vat_percentage",
  "usd_to_sar_rate",
  "commission_client",
  "commission_provider",
  "commission_services",
  "affiliate_discount_percentage",
  "deposit",
  "hold_percent",
  "client_cancellation_window_days",
  "client_cancellation_penalty_percent",
  "provider_cancellation_window_days",
  "provider_cancellation_penalty_percent",
  "late_fee_per_hour",
  "payout_release_hours",
  "delivery_grace_period_hours",
];

export default {
  name: "AppSetting",
  data() {
    return {
      isWaitingRequest: false,
      data: SETTING_KEYS.reduce((acc, key) => {
        acc[key] = null;
        return acc;
      }, {}),
    };
  },
  methods: {
    async getDataToEdit() {
      try {
        let res = await this.$axios.get("settings?key=general");
        const settings = res.data.data[0].value || {};
        SETTING_KEYS.forEach((key) => {
          this.data[key] = settings[key] ?? null;
        });
      } catch (error) {
        console.error(error.response?.data?.message);
      }
    },
    async submitForm() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("key", "general");
      SETTING_KEYS.forEach((key) => {
        if (this.data[key] !== null && this.data[key] !== "") {
          REQUEST_DATA.append(`value[${key}]`, this.data[key]);
        }
      });

      try {
        await this.$axios.post("settings", REQUEST_DATA);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response?.data?.message);
      }
    },
    validateFormInputs() {
      const deposit = Number(this.data.deposit);
      const penalty = Number(this.data.client_cancellation_penalty_percent);
      const hold = Number(this.data.hold_percent) || 0;
      const commissions =
        (Number(this.data.commission_client) || 0) +
        (Number(this.data.commission_provider) || 0) +
        (Number(this.data.commission_services) || 0);

      if (
        this.data.deposit !== null &&
        this.data.deposit !== "" &&
        (deposit < 0 || deposit > 100)
      ) {
        this.$message.error(this.$t("VALIDATION.deposit_percentage_range"));
        return;
      }
      if (
        this.data.client_cancellation_penalty_percent !== null &&
        this.data.client_cancellation_penalty_percent !== "" &&
        penalty >= deposit
      ) {
        this.$message.error(this.$t("VALIDATION.penalty_less_than_deposit"));
        return;
      }
      if (deposit < hold + commissions) {
        this.$message.error(this.$t("VALIDATION.deposit_covers_commissions"));
        return;
      }
      this.submitForm();
    },
  },
  created() {
    this.getDataToEdit();
  },
};
</script>

<style scoped>
.settings_section {
  margin-bottom: 28px;
  padding: 16px 16px 4px;
  border: 1px solid #e6edf8;
  border-radius: 12px;
  background: #fbfcff;
}

.settings_section_title {
  margin: 0 0 8px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e6edf8;
  color: var(--main_theme_clr);
  font-size: 16px;
  font-weight: 700;
}
</style>
